//add modal at before body
class MirrorModalCustomDialog extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }
}
customElements.define('mirror-modal-custom-dialog', MirrorModalCustomDialog);


//manage modal open and close
const openElsMirrorsize = document.querySelectorAll("[data-mirropen-mirr]");
const closeElsMirrorsize = document.querySelectorAll("[data-close-mirr]");
const isVisibleMirrorsize = "is-visible";

for (const el of openElsMirrorsize) {
    el.addEventListener("click", function () {
        const modalId = this.getAttribute("data-mirropen-mirr");
        console.log("modalId==>",modalId)
        document.getElementById(modalId).classList.add(isVisibleMirrorsize);
        // mirrConfigInitMirrosize(this.getAttribute("ms-data-block"))
    });
}

for (const el of closeElsMirrorsize) {
    el.addEventListener("click", function () {
        let _this = this;

        setTimeout(function(){
            mirrConfigRemoveMirrorsize(_this.getAttribute("ms-data-block"));
        },500);
        this.parentElement.parentElement.classList.remove(isVisibleMirrorsize);
    });
}

function mirrConfigRemoveMirrorsize(blockId){
    const iframeContainer = document.getElementById(`ms-configurator-container-${blockId}`);
    const iframe = iframeContainer.querySelector('iframe');
    const spinner = iframeContainer.querySelector('.mirrorsize-spinner-center');
    
    iframe && iframe.remove();
    if (spinner) {
        spinner.style.display = "flex";
    }
    
}

document.querySelectorAll(".custom-product-customise--js").forEach(function(custom3dProduct){
    custom3dProduct.addEventListener("click",function(evt){
            const product3DId = this.getAttribute("data-product-3d-custom-config");
            const product3DSKU = this.getAttribute("data-product-3d-custom-sku");
            const blockId = this.getAttribute("ms-data-block");
            console.log("product3DId==>",product3DId)
            if(product3DId){
                var config = {
                    merchantId: "wael_jari@hotmail.com",
                    apiKey: "fyO7PFuf1SNmhaxupbrL9B9v2rHPmi5cfCvd5Rt4NJBWBGussitb0blvoL99QJ7O",
                    sku: product3DSKU,
                    productId: Number(product3DId),
                    shop: "zdetza-2x.myshopify.com",
                    shopId: "offline_zdetza-2x.myshopify.com",
                    variantId: '',
                    language: '',
                    apiUrl: '',
                    userId: '',
                };
                msConfiguratorMirrorsize(config,blockId);
            }
    })  
})


function msConfiguratorMirrorsize(config, blockId) {
    // var apiBaseUrl = Configurator.config.baseApiUrl;
    var apiBaseUrlMirr = "https://api.services.mirrorsize.com/v1/configurator";
    var container = document.getElementById(`ms-configurator-container-${blockId}`);
    var spinner = container.querySelector('.mirrorsize-spinner-center');

    var iframe = document.createElement('iframe');

    // authenicate
    var authApiAndOpenIframeMirrorsize = function (config) {
        var authXhr = new XMLHttpRequest();
        authXhr.open("POST", apiBaseUrlMirr + '/auth');
        authXhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        authXhr.setRequestHeader("Accept-Language", config.language == undefined || config.language == null || config.language == "" ? "en" : config.language);
        authXhr.send(JSON.stringify(
            {
                merchantId: config.merchantId,
                apiKey: config.apiKey,
                userId: config.userId,
                apiUrl: config.apiUrl,
                productId: config.productId,
                variantId: config.variantId,
                shopId: config.shopId,
                shop: config.shop
            }));

        authXhr.onreadystatechange = function () {
            if (authXhr.readyState === XMLHttpRequest.DONE) {
                if (authXhr.status === 200) {
                    console.log("httpRequest.responseText -> {}", authXhr.responseText);
                    setUrlIframeMirrorsize(JSON.parse(authXhr.responseText));
                } else {
                    throw new Error("Error requesting url iframe. Status: " + authXhr.status + " Response body: " + authXhr.responseText);
                }
            }
        }


        // Set Url In iframe
        var setUrlIframeMirrorsize = function (res) {
            var setXhr = new XMLHttpRequest();
            setXhr.open("POST", apiBaseUrlMirr + '/iframe');
            setXhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            setXhr.setRequestHeader("Authorization", "Bearer " + res.data.token);

            setXhr.send(JSON.stringify(
                {
                    sku: config.sku
                }));

            setXhr.onreadystatechange = function () {
                if (setXhr.readyState === XMLHttpRequest.DONE) {
                    if (setXhr.status === 200) {
                        console.log("httpRequest.responseText -> {}", setXhr.responseText);

                        // clear local storage language
                        localStorage.removeItem('lang');
                        if (spinner) spinner.style.display = "none"

                        iframe.src = JSON.parse(setXhr.responseText).data.configuratorUrl;
                    } else {
                        throw new Error("Error requesting url iframe. Status: " + authXhr.status + " Response body: " + authXhr.responseText);
                    }
                }
            }
        };
    }


    // receive message from iframe
    window.addEventListener('message', function (event) {
        // Check the origin of the iframe to ensure security
        // if (event.origin !== 'https://your-iframe-domain.com') {
        //     return;
        // }

        // receive data from iframe, close iframe and redirect to url
        const receivedData = JSON.parse(event.data);
        if (receivedData.close) {
            // iframe.remove();
            // history.pushState(null, '', '');
            addToCartShopifyMirrorsize(receivedData.userSessionId)
           // window.location.href = receivedData.redirectUrl;
        }
    });


    // iframe iniliatization
    iframe.scrolling = false;
    iframe.frameBorder = 0;
    iframe.allow = "web-share";
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    container.appendChild(iframe);
    authApiAndOpenIframeMirrorsize(config);
}


function addToCartShopifyMirrorsize(userSessionId){
    const loaderElements = document.getElementsByClassName('mirrorsize-custom--loading-overlay');
                Array.from(loaderElements).forEach((element) => {
                    console.log('element', element);
                    element.classList.add('is-active')
                });
    if (userSessionId) {
        fetch("https://api.services.mirrorsize.com/api/sdk/configurator/product-details", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    "merchantId": "wael_jari@hotmail.com",
                    "apiKey": "fyO7PFuf1SNmhaxupbrL9B9v2rHPmi5cfCvd5Rt4NJBWBGussitb0blvoL99QJ7O",
                    "userSessionId": userSessionId
                })
            })
            .then(res => res.json())
            .then(data => {
                let variant_id = data.data.variantId;
              setTimeout(function(){
                       fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            items: [{
                                "id": variant_id,
                                "quantity": 1,
                                'properties': {
                                    'Apparel Name': `${data.data.apparelName ?? ""}`,
                                    "SKU": `${data.data.sku ?? ""}`,
                                    "Fabric Name": `${data.data.pieces[0].fabrics.fabricName ?? ""}`,
                                    "Material Type": `${data.data.pieces[0].fabrics.materialType ?? ""}`,
                                    "Style No": `${data.data.pieces[0].fabrics.styleNo ?? ""}`,
                                }
                            }]
                        })
                    })
                    .then(response => {
                        if (response.error) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json();
                    })
                    .then(data => {
                        window.location.assign("/cart");
                    })
                    .catch(error => {
                        console.error('There was a problem with the fetch operation:', error);
                    });
              }, 5000)
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
    }

}
